"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var encode_1 = __importDefault(require("./methods/encode"));
exports.Encode = encode_1.default;
var decode_1 = __importDefault(require("./methods/decode"));
exports.Decode = decode_1.default;
